import script from "D:\\Kryzalis\\micro24horas.com.br\\src\\assets\\js\\components\\KSlider.vue?type=script"
export * from "D:\\Kryzalis\\micro24horas.com.br\\src\\assets\\js\\components\\KSlider.vue?type=script"

import "D:\\Kryzalis\\micro24horas.com.br\\src\\assets\\js\\components\\KSlider.vue?type=style&index=0"
export default script